import { Field } from '../../../../environments/field';
import { environment } from '../../../../environments/environment';

let token = sessionStorage.getItem('token');

export let fields: Array<Field> = [
  {
    type: 'text',
    name: 'nombre',
    label: 'Nombre',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },

  ];
